import { useState } from "react";
import { C, G } from "../../styles/theme";
import PBtn from "../common/PBtn";

export default function ExitPopup({ onClose, saveDB }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = () => {
    if (!email.trim()) return;
    saveDB("leads", { id: null, name: "Exit Intent Lead", email, phone: "", service: "General Enquiry", company: "", message: "Requested free catalogue via exit popup.", status: "new", date: new Date().toISOString().slice(0, 10) });
    setSent(true);
    setTimeout(onClose, 2800);
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(10,20,40,.78)", zIndex: 3000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(6px)" }}>
      <div style={{ background: "#fff", borderRadius: 18, width: "100%", maxWidth: 480, overflow: "hidden", boxShadow: "0 32px 80px rgba(0,0,0,.4)", position: "relative" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 14, right: 14, background: "rgba(0,0,0,.2)", border: "none", width: 28, height: 28, borderRadius: "50%", cursor: "pointer", fontSize: 13, color: "#fff", zIndex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>x</button>
        <div style={{ background: G.hero, padding: "28px 28px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 44, marginBottom: 7 }}>🎁</div>
          <h2 style={{ color: "#fff", fontWeight: 800, fontSize: 20, marginBottom: 7 }}>Wait! Don't Leave Empty-Handed</h2>
          <p style={{ color: "rgba(255,255,255,.75)", fontSize: 13, lineHeight: 1.65 }}>Get our FREE Lab Products Catalogue with full specs, pricing and compatibility for all 34 GC instruments.</p>
        </div>
        <div style={{ padding: "22px 28px 26px" }}>
          {sent ? (
            <div style={{ textAlign: "center", padding: "8px 0" }}>
              <div style={{ fontSize: 38, marginBottom: 10 }}>✅</div>
              <div style={{ fontWeight: 700, color: C.blue, fontSize: 15, marginBottom: 4 }}>Catalogue sent!</div>
              <div style={{ color: C.gray, fontSize: 13 }}>Check your inbox shortly.</div>
            </div>
          ) : (
            <>
              <div style={{ display: "flex", gap: 7, marginBottom: 14, flexWrap: "wrap" }}>
                {["34 GC Products", "Full Specs", "Price List", "Compatibility Guide"].map(t => (
                  <span key={t} style={{ background: "#f0fdf4", color: "#15803d", fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20 }}>{t}</span>
                ))}
              </div>
              <div className="popup-flex">
                <input value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && submit()} placeholder="Enter your email address" style={{ flex: 1, padding: "10px 13px", border: `1.5px solid ${C.border}`, borderRadius: 8, fontSize: 14, outline: "none" }} />
                <PBtn onClick={submit}>Send Free</PBtn>
              </div>
              <div style={{ fontSize: 11, color: C.gray, marginTop: 9, textAlign: "center" }}>No spam. Unsubscribe anytime.</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
